function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawMindfulness = function UndrawMindfulness(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 985 692.97",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 599.51,
    y1: 796.49,
    x2: 599.51,
    y2: 363.49,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    d: "M297.08 46.32c-12.12 1.58-25.29 4.24-33.3 14.83-9.47 12.52-8.2 31.55-3.91 47.4s11.07 31.3 11 47.9c-.19 26.39-18.21 48.79-38.72 60.6s-43.66 15.62-65.8 22.51a256 256 0 0 0-58.77 26.93c-15.59 9.67-31.27 22.31-37.51 41.39-10.23 31.29 8.59 64.5 27.18 90.19 57 78.77 129.66 154.35 218.48 162 66.35 5.67 132.77-27.89 198.4-15.58 30.15 5.64 58.24 20.66 86.54 33.89s58.07 25 88.58 23.5 62.15-18.8 75.37-50.49c7.81-18.73 8.6-40.45 15.82-59.49 22.12-58.41 91.06-67.89 131.06-111.85 21-23.09 33-54.8 43-86.22 16.15-51.12 28.26-105 25.56-159.35-1.18-23.66-5.6-48.23-18.73-66.49-9.55-13.29-22.88-22.11-35.9-30.64C895.79 17.93 863.97-2.12 829.92.19c-19.62 1.33-38.18 10.06-56.9 16.9-35.66 13-72.86 19.44-109.87 25.79-61.15 10.5-123.18 21-185.16 15.76-27.37-2.33-53.22-11.63-80.15-15.44-32.75-4.63-68.14-1.13-100.76 3.12z",
    fill: primaryColor,
    opacity: 0.2
  }), React.createElement("circle", {
    cx: 791,
    cy: 169.97,
    r: 38,
    fill: primaryColor,
    opacity: 0.5
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M671.33 304.12H323.6l19.87-61.15h10.65l2.13 15.86h275.34l1.42-15.86h12.77l25.55 61.15z"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M671.33 304.12H323.6l19.87-61.15h10.65l2.13 15.86h275.34l1.42-15.86h12.77l25.55 61.15z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M695.46 317.71H292.38l-9.94-24.91h421.54l-8.52 24.91zM682.69 333.57H302.31l-9.93-15.86h403.08l-12.77 15.86z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M302.31 329.04h380.37v18.12H302.31zM279.6 376.6h432.89v67.95H279.6z"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M279.6 376.6h432.89v67.95H279.6z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M985 605.35L0 598.56l28.39-160.81h935.32L985 605.35z"
  }), React.createElement("g", {
    opacity: 0.2
  }, React.createElement("path", {
    d: "M279 555.53h12.58a15 15 0 0 1 15 15v30.3H264v-30.3a15 15 0 0 1 15-15zM371.25 555.53h12.58a15 15 0 0 1 15 15v30.3h-42.58v-30.3a15 15 0 0 1 15-15zM486.21 555.53h12.58a15 15 0 0 1 15 15v30.3h-42.58v-30.3a15 15 0 0 1 15-15zM605.43 555.53H618a15 15 0 0 1 15 15v30.3h-42.57v-30.3a15 15 0 0 1 15-15zM700.53 555.53h12.58a15 15 0 0 1 15 15v30.3h-42.58v-30.3a15 15 0 0 1 15-15z"
  })), React.createElement("path", {
    opacity: 0.2,
    d: "M469.79 444.55h45.42v90.6h-45.42z"
  }), React.createElement("circle", {
    cx: 187.35,
    cy: 632.53,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M279.6 376.6h7.1v67.95h-7.1zM320.76 376.6h7.1v67.95h-7.1zM366.18 376.6h7.1v67.95h-7.1zM410.18 376.6h7.1v67.95h-7.1zM458.44 376.6h7.1v67.95h-7.1zM523.72 376.6h7.1v67.95h-7.1zM567.72 376.6h7.1v67.95h-7.1zM617.4 376.6h7.1v67.95h-7.1zM659.98 376.6h7.1v67.95h-7.1zM705.4 376.6h7.1v67.95h-7.1z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M712.49 381.13H279.6l-25.54-22.65h482.56l-24.13 22.65zM279.6 381.13h17.03v9.06H279.6zM316.51 381.13h17.03v9.06h-17.03zM360.5 381.13h17.03v9.06H360.5zM405.92 381.13h17.03v9.06h-17.03zM454.18 381.13h17.03v9.06h-17.03zM518.05 381.13h17.03v9.06h-17.03zM563.47 381.13h17.03v9.06h-17.03zM613.14 381.13h17.03v9.06h-17.03zM655.72 381.13h17.03v9.06h-17.03zM695.46 381.13h17.03v9.06h-17.03zM739.46 358.48H252.64l-5.68-15.85h496.76l-4.26 15.85z"
  }), React.createElement("path", {
    opacity: 0.2,
    d: "M739.46 358.48H252.64l-5.68-15.85h496.76l-4.26 15.85z"
  }), React.createElement("ellipse", {
    cx: 492.5,
    cy: 335.83,
    rx: 11.35,
    ry: 18.12,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 492.5,
    cy: 335.83,
    rx: 11.35,
    ry: 18.12,
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 492.5,
    cy: 335.83,
    rx: 7.1,
    ry: 11.32,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M766.17 700.64l-48.68-37.36s-3.93-15.57-5.5-26.47-3.93-57.6-3.93-57.6a67.86 67.86 0 0 0 2.21-12.36c.48-.1 1-.22 1.45-.35a24.28 24.28 0 0 0 16.39-14.13c5-12.44-1.46-27.14-9.64-37s-18.47-17.78-23.85-30c-6.64-15.06-4.37-33.26-7.76-49.74a15 15 0 0 0-2.51-6.43c-2.1-2.61-5.39-3.18-8.33-4.22-9.28-3.29-16.24-12.31-21.67-21.72-8.79-15.25-17.89-38.44-36-39.76-6.73-.49-13.76 1.78-20.56 1.76-10.55 0-21 .13-31.46 1.58-3.74.51-7.62 1.21-10.74 3.68-10.71 8.47-5.86 30.86-16.18 40-3.07 2.71-7 3.68-10.47 5.54-13.08 7-18.89 25.67-18.12 42.47.36 7.87 2 16.07 6.65 21.82 3.68 4.6 8.93 7.24 12.36 12.09 5.54 7.83 4.79 18.21 4.19 28.77-7.4 3.1-13.34 6.66-15.21 10.49-6.28 12.84-5.5 56.82-5.5 56.82s2.36 72-15.7 81l-67.53 46.7s-47.9-41.64-59.68-17.12c-8.06 16.77 21.35 26.26 40.74 30.58-12.23 8.68-19 24.72-13.26 35.59 9 17.12 34.16 28.8 34.16 28.8s95.95 4.63 140.3-5.31h.73c18.83 3.41 45.85 7 67.52 4.84.41 1 .7 1.64.7 1.64s139 11.68 164.11-35.81c12.89-24.35-.56-35.6-16.72-40.78 18.09-1.44 38.69-6.5 41.06-21.88 4.35-28.04-63.57 3.87-63.57 3.87zm-14 14.89c-25.43 9.27-46.08 9.79-57.07 9.09-5.41-11.77-27.92-62.79-28.51-96.93.14-7.62 1.5-14.28 4.54-19.28 6.55-10.77 8.48-19.21 8.26-25.63v-1.4a26.07 26.07 0 0 0-.57-5.84 15.32 15.32 0 0 1 .93 8.34c-2.36 12.07 3.93 90.29 3.93 90.29s5.1 17.51 15.7 22.57zM503.12 710l24.34-15.57s11.39-5.43 12.54-18.7l8-63.23a65.12 65.12 0 0 0 2.16 8c1.42 4.15 2 10.23 2.11 17.47C552 673.22 540 731.78 540 731.78h.15l-.09.42-.85.05c-19.75-.6-65.77-2.32-91.54-5.89zm-42.65 36.86v.14h-6z",
    transform: "translate(-107.5 -103.51)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M545.02 306.11c5.25 9.18 12 18 20.95 21.18 2.84 1 6 1.57 8 4.11a14.74 14.74 0 0 1 2.42 6.27c3.27 16.07 1.08 33.82 7.5 48.5 5.2 11.89 15.15 19.64 23.06 29.23s14.12 23.93 9.32 36.05a23.53 23.53 0 0 1-15.77 13.78c-6.62 1.79-13.53 1-20.25-.15-8.86-1.57-17.88-4-25.26-10-12.77-10.37-18.17-29-24.85-45.56-3.14-7.76-7.31-15.89-14.21-18.67-7.91-3.18-16.79 2.13-21.92 9.92s-7.41 17.58-9.89 27c-2.8 10.63-6.35 21.68-13.71 28.63a23.08 23.08 0 0 1-24.64 4.93c-8.2-3.42-14.69-12.06-16.57-22.09-2.91-15.46 4.06-34-4.49-46.22-3.32-4.73-8.39-7.31-12-11.79-4.45-5.61-6.08-13.6-6.43-21.27-.75-16.38 4.87-34.63 17.51-41.41 3.38-1.81 7.15-2.76 10.12-5.4 10-8.88 5.29-30.71 15.64-39 3-2.41 6.76-3.08 10.38-3.59 10.14-1.41 20.21-1.57 30.41-1.54 6.58 0 13.37-2.19 19.88-1.71 17.51 1.32 26.28 23.93 34.8 38.8z",
    fill: "#965d7b"
  }), React.createElement("path", {
    fill: "#575988",
    d: "M357.29 637.16l3.83 45.37L629 680.94l-5.1-49.53-90.57-10.54-158.82 9.58-17.22 6.71z"
  }), React.createElement("path", {
    opacity: 0.05,
    d: "M357.29 637.16l3.83 45.37L629 680.94l-5.1-49.53-90.57-10.54-158.82 9.58-17.22 6.71z"
  }), React.createElement("path", {
    d: "M533.56 668.88l-89.18 8.35s61.1 15.56 96.77 8z",
    fill: "#f7c4a7"
  }), React.createElement("path", {
    d: "M533.56 668.88l-89.18 8.35s61.1 15.56 96.77 8z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M465.63 349.35s17.46 45.92-8.35 66.41-4.55 77.8-4.55 77.8l99.43-4.55s9.87-64.51 4.55-78.18c0 0-23.53 6.83-28.84-7.59s-9.11-53.89-9.11-53.89z",
    fill: "#f7c4a7"
  }), React.createElement("path", {
    d: "M442.86 627.13s-83.87-1.9-108.53-8-45.92 23.15-37.19 39.85 33 28.08 33 28.08 124.85 6.07 151.8-11c0 0 10.25-29.22 0-34.91H351.79l96-1.9zM576.07 618.41s28.08 6.07 66.79-9.11c0 0 72.48-2.28 48.2 44s-158.63 34.91-158.63 34.91-8-17.08 0-21.63 77.42-33.77 99-32.26l-60 11.76z",
    fill: "#575988"
  }), React.createElement("path", {
    d: "M522.2 371.44c-1.45-10.81-2.3-19.62-2.3-19.62h-53.13a103.6 103.6 0 0 1 5.08 21.48 41.75 41.75 0 0 0 50.35-1.86z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 494.66,
    cy: 336.63,
    r: 41.74,
    fill: "#f7c4a7"
  }), React.createElement("path", {
    d: "M470.19 409.31s-50.09 9.49-56.16 22-5.31 55.41-5.31 55.41 2.28 70.21-15.18 78.93l-65.27 45.54s-46.3-40.61-57.68-16.7 54.65 32.64 54.65 32.64l73.62-22 23.53-15.18s11-5.31 12.14-18.22l9.87-78.18 39.47-11.38h63.73l8.54-24.38s15.75 12.62 13.47 24.38 3.79 88 3.79 88 4.93 17.08 15.18 22l59.21 21.32s62.62 6.07 66.79-21.25-61.48 3.79-61.48 3.79l-47.06-36.43s-3.79-15.18-5.31-25.81-3.79-56.16-3.79-56.16 14.42-47.82-27.32-56.16l-53.89-16.7z",
    fill: "#f7c4a7"
  }), React.createElement("path", {
    d: "M436.6 418.98l7.78 51.42s-8 23.91 0 47.44-9.88 111.19-9.88 111.19 93.73 30 151-4.55c0 0-42.12-88.8-24.29-118.4s.29-41.18.29-41.18l2.8-54.41-12.9-3.79-7.59 53.79s-52.37 36.43-91.08 4.55l-8.35-58.44z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M490.74 480.1a30.73 30.73 0 0 0-39.79-11.19c12.71 9.51 26.72 12.05 39.79 11.19zM512.25 474.4a30.73 30.73 0 0 1 39.79-11.19c-12.7 9.51-26.72 12.06-39.79 11.19z",
    fill: "#fff",
    opacity: 0.07
  }), React.createElement("path", {
    d: "M436.6 418.98l7.78 48.76s-8 23.91 0 47.44-9.88 111.19-9.88 111.19 93.73 30 151-4.55c0 0-42.12-88.8-24.29-118.4s.29-41.18.29-41.18l2.74-54.45-12.9-3.79-7.59 53.89s-52.37 36.43-91.08 4.55L444.32 404z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M436.22 418.6l8.16 49.9s-8 23.91 0 47.44-9.88 111.19-9.88 111.19 93.73 30 151-4.55c0 0-42.12-88.8-24.29-118.4s.29-41.18.29-41.18l2.74-54.45-12.9-3.79-7.59 53.89s-52.37 36.43-91.08 4.55l-8.35-58.44z",
    fill: "#fc6681"
  }), React.createElement("path", {
    d: "M474.74 645.73l19.76-2.66s22.77-29.22 39.09-6.83c0 0 6.83 14.42 15.18 17.08a112.22 112.22 0 0 0 17.46 3.79l-33.77 9.49s-14.8 8.73-30.36 6.45a59 59 0 0 0-27.32 2.28z",
    fill: "#f7c4a7"
  }), React.createElement("path", {
    d: "M452.92 521.82s35.67 5.31 41.74-4.17M520.5 515.75s6.83 6.83 34.15 1.9M451.02 409.87s26.18 3.79 31.12 1.52M508.71 409.87s26.18 3.79 31.12 1.52M477.59 642.88s7.21 34 0 35.2-17.46-5.6-17.46-6.36 4.55-22.39 4.55-22.39z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M476.83 642.88s7.21 34 0 35.2-17.46-5.6-17.46-6.36 4.55-22.39 4.55-22.39z",
    fill: "#575988"
  }), React.createElement("path", {
    d: "M441.6 404.9c-3.18 7.39-4.31 16.11-.93 23.41 2.58 5.57 7.62 10.08 8.59 16.14 1.22 7.6-4.41 15.33-2.31 22.73.8 2.84 2.67 5.24 4.57 7.49 5.78 6.83 13.46 13.44 22.38 12.91 1.41-13.78-10.5-27.15-6.6-40.44 1.4-4.76 4.68-8.72 6.66-13.26 3.29-7.53 2.82-16.13 1.63-24.26-1.73-11.79-6.11-26.26-17.8-31.78-5.38-2.54-13-2.72-14.92 4.17-1 3.68 1.4 7.14 1.73 10.74.42 4.57-1.23 8.04-3 12.15z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M441.6 403.76c-3.18 7.39-4.31 16.11-.93 23.41 2.58 5.57 7.62 10.08 8.59 16.14 1.22 7.6-4.41 15.33-2.31 22.73.8 2.84 2.67 5.24 4.57 7.49 5.78 6.83 13.46 13.44 22.38 12.91 1.41-13.78-10.5-27.15-6.6-40.44 1.4-4.76 4.68-8.72 6.66-13.26 3.29-7.53 2.82-16.13 1.63-24.26-1.73-11.79-6.11-26.26-17.8-31.78-5.38-2.54-13-2.72-14.92 4.17-1 3.68 1.4 7.14 1.73 10.74.42 4.58-1.23 8.05-3 12.15z",
    fill: "#965d7b"
  }), React.createElement("path", {
    d: "M444.57 316.14s55.41-7.59 56.92 3.79 50.47 30 50.47 30l-12.14-30-22.39-37.19s-41-3-42.88 0-23.53 12.9-23.53 12.9z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M444.57 315.38s55.41-7.59 56.92 3.79 50.47 30 50.47 30l-12.14-30-22.39-37.18s-41-3-42.88 0-23.53 12.9-23.53 12.9z",
    fill: "#965d7b"
  }), React.createElement("path", {
    d: "M540.99 396.49a27 27 0 0 1 5.56 11.13c.92 3.91.95 8 1.83 11.92 1.87 8.35 7.39 15.37 13.16 21.69a23.67 23.67 0 0 0 6.72 5.66c2.64 1.3 6 1.57 8.45 0-2.32-1.9-3.58-4.81-4.41-7.7a39.58 39.58 0 0 1-1.54-12.41c.25-7 2.3-14.39-.61-20.77-1.68-3.68-4.81-6.48-8-9a42.61 42.61 0 0 0-7.14-4.7c-4.71-2.35-10.12-3.38-15.32-3.89-6.78-.7-.85 5.49 1.3 8.07z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M540.99 395.34a27 27 0 0 1 5.56 11.15c.92 3.91.95 8 1.83 11.92 1.87 8.35 7.39 15.37 13.16 21.69a23.67 23.67 0 0 0 6.72 5.66c2.64 1.3 6 1.57 8.45 0-2.32-1.9-3.58-4.81-4.41-7.7a39.58 39.58 0 0 1-1.54-12.41c.25-7 2.3-14.39-.61-20.77-1.68-3.68-4.81-6.48-8-9a42.61 42.61 0 0 0-7.14-4.7c-4.71-2.35-10.12-3.38-15.32-3.89-6.78-.71-.85 5.48 1.3 8.05z",
    fill: "#965d7b"
  }), React.createElement("path", {
    d: "M516.18 165.41h-6.88a4.82 4.82 0 1 0 0-9.63h-55.73a4.82 4.82 0 0 0 0 9.63h6.88a4.82 4.82 0 1 0 0 9.63h-9.63a4.82 4.82 0 1 0 0 9.63h55.73a4.82 4.82 0 1 0 0-9.63h9.63a4.82 4.82 0 1 0 0-9.63zM786.18 165.41h-6.88a4.82 4.82 0 1 0 0-9.63h-55.73a4.82 4.82 0 0 0 0 9.63h6.88a4.82 4.82 0 1 0 0 9.63h-9.63a4.82 4.82 0 1 0 0 9.63h55.73a4.82 4.82 0 1 0 0-9.63h9.63a4.82 4.82 0 1 0 0-9.63zM211.18 288.41h-6.88a4.82 4.82 0 1 0 0-9.63h-55.73a4.82 4.82 0 0 0 0 9.63h6.88a4.82 4.82 0 0 0 0 9.63h-9.63a4.82 4.82 0 1 0 0 9.63h55.73a4.82 4.82 0 1 0 0-9.63h9.63a4.82 4.82 0 0 0 0-9.63z",
    fill: "#252223",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M788.73 675.12s-24.67-83.76 4.63-145.41c12.3-25.87 16.38-54.92 10.7-83a222.5 222.5 0 0 0-11.75-39",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M810.5 368.8c0 10.27-18.59 40-18.59 40s-18.59-29.77-18.59-40a18.59 18.59 0 1 1 37.17 0zM841.26 425.66c-5.58 8.62-37.36 23.5-37.36 23.5s.58-35.09 6.16-43.71a18.59 18.59 0 0 1 31.2 20.2zM839.91 522.83c-9.17 4.62-44.11 1.43-44.11 1.43s18.21-30 27.38-34.62a18.59 18.59 0 1 1 16.74 33.19zM822.34 596.12c-8.25 6.1-43.24 8.86-43.24 8.86s12.88-32.64 21.13-38.75a18.59 18.59 0 1 1 22.11 29.89zM764.87 451.15c7.36 7.15 41.67 14.56 41.67 14.56s-8.4-34.07-15.76-41.23a18.59 18.59 0 0 0-25.9 26.66zM745.41 537.12c9.17 4.62 44.11 1.43 44.11 1.43s-18.21-30-27.38-34.62a18.59 18.59 0 1 0-16.74 33.19zM737.96 623.28c8.25 6.1 43.24 8.86 43.24 8.86s-12.88-32.65-21.14-38.75a18.59 18.59 0 1 0-22.11 29.89z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M810.5 368.8c0 10.27-18.59 40-18.59 40s-18.59-29.77-18.59-40a18.59 18.59 0 1 1 37.17 0zM841.26 425.66c-5.58 8.62-37.36 23.5-37.36 23.5s.58-35.09 6.16-43.71a18.59 18.59 0 0 1 31.2 20.2zM839.91 522.83c-9.17 4.62-44.11 1.43-44.11 1.43s18.21-30 27.38-34.62a18.59 18.59 0 1 1 16.74 33.19zM822.34 596.12c-8.25 6.1-43.24 8.86-43.24 8.86s12.88-32.64 21.13-38.75a18.59 18.59 0 1 1 22.11 29.89zM764.87 451.15c7.36 7.15 41.67 14.56 41.67 14.56s-8.4-34.07-15.76-41.23a18.59 18.59 0 0 0-25.9 26.66zM745.41 537.12c9.17 4.62 44.11 1.43 44.11 1.43s-18.21-30-27.38-34.62a18.59 18.59 0 1 0-16.74 33.19zM737.96 623.28c8.25 6.1 43.24 8.86 43.24 8.86s-12.88-32.65-21.14-38.75a18.59 18.59 0 1 0-22.11 29.89z",
    fill: "#fc6681"
  }), React.createElement("path", {
    d: "M206.73 673.12s-24.67-83.76 4.63-145.41c12.3-25.87 16.38-54.92 10.7-83a222.5 222.5 0 0 0-11.75-39",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M228.5 366.8c0 10.27-18.59 40-18.59 40s-18.59-29.77-18.59-40a18.59 18.59 0 1 1 37.17 0zM259.26 423.66c-5.58 8.62-37.36 23.5-37.36 23.5s.58-35.09 6.16-43.71a18.59 18.59 0 0 1 31.2 20.2zM257.91 520.83c-9.17 4.62-44.11 1.43-44.11 1.43s18.21-30 27.38-34.62a18.59 18.59 0 0 1 16.74 33.19zM240.34 594.12c-8.25 6.1-43.24 8.86-43.24 8.86s12.88-32.64 21.13-38.75a18.59 18.59 0 1 1 22.11 29.89zM182.87 449.15c7.36 7.15 41.67 14.56 41.67 14.56s-8.4-34.07-15.76-41.23a18.59 18.59 0 0 0-25.9 26.66zM163.41 535.12c9.17 4.62 44.11 1.43 44.11 1.43s-18.21-30-27.38-34.62a18.59 18.59 0 0 0-16.74 33.19zM155.96 621.28c8.25 6.1 43.24 8.86 43.24 8.86s-12.88-32.65-21.14-38.75a18.59 18.59 0 1 0-22.11 29.89z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M228.5 366.8c0 10.27-18.59 40-18.59 40s-18.59-29.77-18.59-40a18.59 18.59 0 1 1 37.17 0zM259.26 423.66c-5.58 8.62-37.36 23.5-37.36 23.5s.58-35.09 6.16-43.71a18.59 18.59 0 0 1 31.2 20.2zM257.91 520.83c-9.17 4.62-44.11 1.43-44.11 1.43s18.21-30 27.38-34.62a18.59 18.59 0 0 1 16.74 33.19zM240.34 594.12c-8.25 6.1-43.24 8.86-43.24 8.86s12.88-32.64 21.13-38.75a18.59 18.59 0 1 1 22.11 29.89zM182.87 449.15c7.36 7.15 41.67 14.56 41.67 14.56s-8.4-34.07-15.76-41.23a18.59 18.59 0 0 0-25.9 26.66zM163.41 535.12c9.17 4.62 44.11 1.43 44.11 1.43s-18.21-30-27.38-34.62a18.59 18.59 0 0 0-16.74 33.19zM155.96 621.28c8.25 6.1 43.24 8.86 43.24 8.86s-12.88-32.65-21.14-38.75a18.59 18.59 0 1 0-22.11 29.89z",
    fill: "#fc6681"
  }));
};
UndrawMindfulness.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawMindfulness;